import { SearchCriteria } from "../search-criteria";

export class GetAttachmentTypesCriteria extends SearchCriteria {

  constructor() {
    super();
  }
}
